import React from "react";
import { StyledShell } from "./Shell.styles";

export const Shell = ({ children }) => <StyledShell>{children}</StyledShell>;
